<h2 mat-dialog-title>Nouveau Devis</h2>

<mat-dialog-content class="dialog-content">

  <p class="hint">
    Sélectionnez la fiche d'expression de besoin pour laquelle créer un devis.<br>
    Seules les fiches en attente de validation CDC sont disponibles.
  </p>

  <div *ngIf="loading" class="loading-row">
    <mat-spinner diameter="24"></mat-spinner>
    <span>Chargement des fiches…</span>
  </div>

  <mat-form-field *ngIf="!loading" appearance="outline" class="full-width">
    <mat-label>Fiche Expression de Besoin</mat-label>
    <input matInput
           [formControl]="searchCtrl"
           [matAutocomplete]="autoFeb"
           placeholder="Rechercher par libellé ou demandeur…">
    <mat-autocomplete #autoFeb="matAutocomplete"
                      [displayWith]="displayFn"
                      (optionSelected)="onSelectFeb($event.option.value)">
      <mat-option *ngFor="let feb of filteredFebs$ | async" [value]="feb">
        <span class="feb-label">{{ feb.febLabel }}</span>
        <span class="feb-sub" *ngIf="feb.febDemandeurNom"> — {{ feb.febDemandeurNom }}</span>
      </mat-option>
      <mat-option *ngIf="(filteredFebs$ | async)?.length === 0" disabled>
        Aucune fiche disponible
      </mat-option>
    </mat-autocomplete>
    <mat-error>Veuillez sélectionner une FEB</mat-error>
  </mat-form-field>

  <!-- Champs CDC — affichés après sélection d'une FEB -->
  <div *ngIf="selectedFeb" class="chiffrage-section">
    <div class="section-header">Chiffrage CDC</div>
    <form [formGroup]="devisForm">

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-col">
          <mat-label>Date de démarrage</mat-label>
          <input matInput [matDatepicker]="pickerDemarrage" formControlName="devisDateDemarrageGo" readonly>
          <mat-datepicker-toggle matSuffix [for]="pickerDemarrage"></mat-datepicker-toggle>
          <mat-datepicker #pickerDemarrage></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-col">
          <mat-label>Durée prévisionnelle (jours)</mat-label>
          <input matInput type="number" formControlName="devisDuree" min="0">
        </mat-form-field>
      </div>

      <!-- ── Date d'entretien — OBLIGATOIRE ───────────────────── -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-col">
          <mat-label>Date d'entretien <span class="required-star">*</span></mat-label>
          <input matInput
                 [matDatepicker]="pickerEntretien"
                 formControlName="devisDateEntretien"
                 readonly>
          <mat-datepicker-toggle matSuffix [for]="pickerEntretien"></mat-datepicker-toggle>
          <mat-datepicker #pickerEntretien></mat-datepicker>
          <mat-error *ngIf="devisForm.get('devisDateEntretien')?.hasError('required')">
            La date d'entretien est obligatoire
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">

        <!-- Provision frais : number, 2 décimales, prérempli depuis FEB (0 si absent) -->
        <mat-form-field appearance="outline" class="form-col">
          <mat-label>Provision frais (€)</mat-label>
          <input matInput
                 type="number"
                 formControlName="devisProvisionFrais"
                 min="0"
                 step="0.01">
          <span matTextSuffix>€</span>
        </mat-form-field>

        <!-- Prix UO Proposé — éditable -->
        <mat-form-field appearance="outline" class="form-col">
          <mat-label>Prix UO Proposé (€)</mat-label>
          <input matInput
                 type="number"
                 formControlName="devisPrixUoPropose"
                 min="0"
                 step="0.01">
          <span matTextSuffix>€</span>
        </mat-form-field>

        <!-- Prix UO Grille — lecture seule, calculé depuis la nomenclature -->
        <mat-form-field appearance="outline" class="form-col">
          <mat-label>Prix UO Grille (€)</mat-label>
          <input matInput
                 type="text"
                 [value]="prixUoGrilleDisplay != null ? (prixUoGrilleDisplay | number:'1.2-2') : '—'"
                 readonly>
          <span matTextSuffix>€</span>
          <mat-hint>Lecture seule </mat-hint>
        </mat-form-field>

      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-col">
          <mat-label>Bénéficiaire</mat-label>
          <input matInput formControlName="devisBeneficiaire">
        </mat-form-field>
        <div class="form-col toggle-col">
          <mat-slide-toggle formControlName="devisMajore" color="primary">Prix majoré</mat-slide-toggle>
        </div>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-col">
          <mat-label>Numéro de contrat</mat-label>
          <input matInput formControlName="devisNumeroContrat">
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-col">
          <mat-label>Nom du contrat</mat-label>
          <input matInput formControlName="devisNomContrat">
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Commentaire</mat-label>
        <textarea matInput formControlName="devisCommentaire" rows="3"></textarea>
      </mat-form-field>

      <!-- Récapitulatif calculé -->
      <div class="recap-row">
        <div class="recap-item">
          <span class="recap-label">Montant Total estimé</span>
          <span class="recap-value recap-total">
            {{ montantTotalCalcule != null ? (montantTotalCalcule | number:'1.2-2') + ' €' : '—' }}
          </span>
        </div>
      </div>

    </form>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="creating">Annuler</button>
  <button mat-raised-button color="primary"
          [disabled]="!canCreate() || creating"
          (click)="onCreate()">
    <mat-spinner *ngIf="creating" diameter="16" class="btn-spinner"></mat-spinner>
    Créer le Devis
  </button>
</mat-dialog-actions>